import React from "react";
import { Container } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import NavBar from "../../Components/NavBar";
import api from "../../../Services/Api/api";
import { toLocaleString } from "../../../Modules/utils/etc";
import _ from "lodash";
import ChangePercantage from "../../../Components/etc/ChangePercentage";

const SCREEN_NAME = "DASHBOARD_SCREEN";

class DashboardScreen extends AppComponent {
  componentDidMount() {
    this.onMount();
    this.load();
  }

  async load() {
    try {
      await this.setAsyncState({ loading: true, error: null });
      const data = await api.get("v1/report");
      await this.setAsyncState({ data, loading: false });
    } catch (e) {
      await this.setAsyncState({ loading: false, error: e.message });
    }
  }

  renderBalanceRow(data) {
    return (
      <div style={{ paddingBottom: "0.5rem" }}>
        <div
          style={{
            color: "gray",
            marginLeft: "0.5rem",
            marginBottom: "-0.5rem",
          }}
        >
          Balance Report
        </div>
        <div className="row1">
          {[
            { title: "Total Balance", key: "total" },
            { title: "Loan Balance", key: "loan" },
            { title: "Deposit Balance", key: "deposit" },
          ].map(({ title, key }) => {
            return (
              <div className="card1" key={key}>
                <div
                  style={{
                    fontSize: "small",
                    color: "gray",
                  }}
                >
                  {title}
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    color:
                      data?.[key] > 0
                        ? "green"
                        : data?.[key] < 0
                        ? "red"
                        : "gray",
                  }}
                >
                  {toLocaleString(data?.[key]) || " - "}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderTransactionCard({ key, title }, data) {
    if (this.state.loading) return null;
    return (
      <div className="card1" key={key}>
        <div
          style={{
            fontSize: "small",
            color: "gray",
          }}
        >
          {title || _.startCase(key)}
        </div>
        <div
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            textAlign: "center",
            color:
              data?.current?.[key] > 0
                ? "green"
                : data?.current?.[key] < 0
                ? "red"
                : "gray",
            // display: "flex",
            // alignItems: "baseline",
            // justifyContent: "space-around",
          }}
        >
          {toLocaleString(data?.current?.[key] || 0)}{" "}
        </div>

        <div
          style={{
            fontSize: "0.7rem",
            fontWeight: "bold",
            textAlign: "left",
            color: "gray",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>
            Prev Month:
            <span
              style={{
                textAlign: "right",
                color:
                  data?.prev?.[key] > 0
                    ? "green"
                    : data?.prev?.[key] < 0
                    ? "red"
                    : "gray",
              }}
            >
              {" "}
              {toLocaleString(data?.prev?.[key]) || " - "}
            </span>
          </span>
          <span style={{ fontSize: "0.6rem" }}>
            Change:{" "}
            <ChangePercantage
              {...{
                current: data?.current?.[key] || 0,
                previous: data?.prev?.[key] || 0,
              }}
            />
          </span>
        </div>
      </div>
    );
  }

  renderTransactionRow(data) {
    return (
      <div style={{ paddingBottom: "0.5rem" }}>
        <div
          style={{
            color: "gray",
            marginLeft: "0.5rem",
            marginBottom: "-0.5rem",
          }}
        >
          Current Month's Transactions
        </div>
        <div className="row1">
          {[
            { key: "total", title: "All" },
            { key: "deposit" },
            { key: "withdraw" },
          ].map((x) => this.renderTransactionCard(x, data))}
        </div>
        <div className="row1">
          {[
            // { key: "total" },
            { key: "toLoan" },
            { key: "toInterest" },
            { key: "recovery" },
          ].map((x) => this.renderTransactionCard(x, data))}
        </div>
      </div>
    );
  }

  render() {
    const {
      state: { loading, error, data },
      props: { hideLogo = false },
    } = this;

    const content = (
      <div className="dashboard">
        {loading ? <div>Loading..</div> : null}
        {error ? <div className="errormsg">{error}</div> : null}

        {this.renderBalanceRow(data?.balance)}
        {this.renderTransactionRow(data?.transaction)}
      </div>
    );

    return (
      <>
        <NavBar activeLink="/" />
        {hideLogo ? (
          <Container className="gainner">{content}</Container>
        ) : (
          <div
            onClick={() => this.props.setScreenState({ hideLogo: true })}
            className="logobg"
            style={{
              // position: "absolute",
              // top: 0,
              // bottom: 0,
              // left: 0,
              // right: 0,
              // display: "flex",
              // backgroundImage: "radial-gradient(#3d402a 26%, black 114%)",
            }}
          >
            <img
              alt="logo"
              src={require("../../../Assets/img/tnlender.png")}
              className="dashlogo"
              style={{
                width: "50%",
                display: "block",
                margin: "auto",
              }}
            />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  hideLogo: state.vState[SCREEN_NAME]?.hideLogo,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardScreen);
